import React from 'react';
import ReactLoading from 'react-loading';
 
const Example = ({ type, color }) => (
    <ReactLoading type={"spin"} color={"white"} height={'5%'} width={'5%'} />
);
 
export default Example;